import { configureStore } from '@reduxjs/toolkit'
import authReducer from "@/reducers/authReducer.ts";

export default configureStore({
    reducer: {
        auth: authReducer
    },
})